import React from 'react';
import ReactDOM from 'react-dom/client';
import PrimeReact from 'primereact/api';
import App from './App';
import reportWebVitals from './reportWebVitals';

import './styles/index.scss';

//core
import "primereact/resources/primereact.min.css";
//icons
import "primeicons/primeicons.css";
import 'primeflex/primeflex.css';
//theme
import "primereact/resources/themes/arya-orange/theme.css";

PrimeReact.ripple = true;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
